import { render, staticRenderFns } from "./ReplyEditLog.vue?vue&type=template&id=0f581f3a&scoped=true&"
import script from "./ReplyEditLog.vue?vue&type=script&lang=js&"
export * from "./ReplyEditLog.vue?vue&type=script&lang=js&"
import style0 from "./ReplyEditLog.vue?vue&type=style&index=0&id=0f581f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f581f3a",
  null
  
)

export default component.exports